import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type SiteSearchScope = "casino" | "sports";

export interface SiteSearchState {
  open: boolean;
  /** The tab it opens on; null picks the half of the site the player is in. */
  scope: SiteSearchScope | null;
  /** A term to start with (a sport favourite in the sidebar). */
  term: string;
}

const initialState: SiteSearchState = { open: false, scope: null, term: "" };

/** The one search dialog of the site, opened from the header, the phone's bar or a link. */
const siteSearchSlice = createSlice({
  name: "siteSearch",
  initialState,
  reducers: {
    openSiteSearch(
      state,
      action: PayloadAction<{ scope?: SiteSearchScope; term?: string } | undefined>,
    ) {
      state.open = true;
      state.scope = action.payload?.scope ?? null;
      state.term = action.payload?.term ?? "";
    },
    closeSiteSearch(state) {
      state.open = false;
    },
  },
});

export const { openSiteSearch, closeSiteSearch } = siteSearchSlice.actions;
export default siteSearchSlice.reducer;
